module.exports = __webpack_public_path__ + "img/11.3f423b3e.jpg";